<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <div edsPadding edsPaddingBottom="md" *ngIf="showAnalizyRating">
      <div edsGrid class="border">
        <div class="container container--wide">
          <div edsRow>
            <div edsPadding edsPaddingAll="lg">
              <!-- title row -->
              <div edsRow>
                <div edsCol>
                  <eds-title
                    size="h6"
                    theme="primary"
                    isLight="true"
                    edsPadding
                    edsPaddingBottom="xs"
                  >
                    {{ titleLabel }}
                  </eds-title>

                  <p class="text-muted">
                    {{ dateLabel }}
                  </p>
                </div>
              </div>

              <!-- rating category and analizy info row -->
              <div edsRow>
                <!-- category column, with rating images -->
                <div edsCol [columnNumbers]="{ l: 3, m: 6, s: 4 }">
                  <div
                    edsFlexbox
                    flexDirection="row"
                    edsPadding
                    edsPaddingBottom="sm"
                  >
                    <div
                      [ngStyle]="{ 'width.px': 100 }"
                      edsPadding
                      edsPaddingRight="xs"
                    >
                      <eds-image [imgSrc]="month12DisplayUrl"></eds-image>
                    </div>
                    <div [ngStyle]="{ 'width.px': 100 }">
                      <eds-image [imgSrc]="month36DisplayUrl"></eds-image>
                    </div>
                  </div>

                  <div edsPadding edsPaddingBottom="xl">
                    <div><b>Kategoria Analiz Online</b></div>
                    <div>{{ category }}</div>
                  </div>
                </div>

                <!-- analizy rating info column -->
                <div edsCol [columnNumbers]="{ l: 7, m: 6, s: 4 }">
                  <div
                    [ngStyle]="{ 'width.px': 200 }"
                    edsPadding
                    edsPaddingBottom="sm"
                  >
                    <eds-image [imgSrc]="analizyLogoUrl"></eds-image>
                  </div>

                  <div edsPadding edsPaddingTop="xs">
                    {{ analizyInfoLabel }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5>Analizy Rating Component</h5>
</ng-template>
